"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthNBanner = void 0;
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const AuthNBanner_styles_1 = require("./AuthNBanner.styles");
const useWindowWidth_1 = __importDefault(require("../../../lib/useWindowWidth"));
/** Component for rendering an authentication banner.
 * This banner is useful for rendering a login/logout UI for third-party EHR systems.
 * Arbitrary content is accepted by the component to allow for greater customization
 * and arbitrary placement within the direct-booking flow.
 * Accepted content:
 * - header: the main content describing the authentication purpose
 * - description: secondary content describing the authentication purpose
 * - action: component responsible for triggering the authentication flow
 * - separatorContent: optional content used to separate the banner from other content on the page
 */
const AuthNBanner = (_a) => {
    var { children, header, description, action, separatorContent, 'data-testid': dataTestId } = _a, props = __rest(_a, ["children", "header", "description", "action", "separatorContent", 'data-testid']);
    const { aboveMd } = (0, useWindowWidth_1.default)();
    return (react_1.default.createElement(AuthNBanner_styles_1.Container, Object.assign({ "data-testid": dataTestId }, props, { isAboveMd: aboveMd }), children ? (children({
        header,
        description,
        action,
        separatorContent
    })) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(AuthNBanner_styles_1.InfoContainer, null,
            header,
            description),
        react_1.default.createElement(AuthNBanner_styles_1.ActionContainer, { isAboveMd: aboveMd }, action),
        separatorContent &&
            (typeof separatorContent === 'string' ? (react_1.default.createElement(AuthNBanner_styles_1.Separator, { content: separatorContent })) : (separatorContent))))));
};
exports.AuthNBanner = AuthNBanner;
exports.AuthNBanner.defaultProps = {};
exports.AuthNBanner.propTypes = {
    /** Optional render prop for full customization. Exposes all other props. */
    children: prop_types_1.default.func,
    /** the main content describing the authentication purpose */
    header: function (props, propName, componentName) {
        if (!props[propName] && !props.description) {
            return new Error(`Invalid props supplied. \`${propName}\` must be supplied to \`${componentName}\` if no \`description\` is supplied.`);
        }
        prop_types_1.default.checkPropTypes({
            [propName]: prop_types_1.default.oneOfType([prop_types_1.default.element, prop_types_1.default.string])
        }, props, propName, componentName);
    },
    /** secondary content describing the authentication purpose */
    description: function (props, propName, componentName) {
        if (!props[propName] && !props.header) {
            return new Error(`Invalid props supplied. \`${propName}\` must be supplied to \`${componentName}\` if no \`header\` is supplied.`);
        }
        prop_types_1.default.checkPropTypes({
            [propName]: prop_types_1.default.oneOfType([prop_types_1.default.element, prop_types_1.default.string])
        }, props, propName, componentName);
    },
    /** component responsible for triggering the authentication flow */
    action: prop_types_1.default.oneOfType([prop_types_1.default.element, prop_types_1.default.string]).isRequired,
    /** optional content used to separate the banner from other content on the page */
    separatorContent: prop_types_1.default.oneOfType([prop_types_1.default.element, prop_types_1.default.string]),
    'data-testid': prop_types_1.default.string
};
//# sourceMappingURL=AuthNBanner.js.map